<template>
    <div v-if="isLoading" class="loading-container">
        <img :src="require('@/assets/10.png')" alt="Logo" class="loading-logo" />
    </div>
    <div v-else>
        <div class="slide">
            <div class="bg-img">
                <div class="slide-content">
                    <div><h2 class="slide-header"> {{ $t('message.ourRequests') }}</h2></div>
                <div>
                    <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                    <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
                    <h5 class="slide-h5"> {{ $t('message.PendingPMs') }}</h5>
                </div>
            </div>
            </div>
        </div>
        <div class="container custom-container-orders mt-5">
            <b-row class="">
                <b-col cols="6" class="d-flex align-items-center">
                    <h3 class="filter-text">{{ $t('message.filter') }}</h3>
                    <b-form-input class="filter-input" id="filter-input" v-model="filter"
                    :placeholder="$t('message.adminName')"></b-form-input>
                </b-col>
                <b-col cols="6" class="text-right">
                    <b-button variant="warning" class="new-order" @click="openAddEquipmentModal">
                    <b-icon icon="plus-circle" class="mr-2"></b-icon>
                    {{ $t('message.addEquipment') }}
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col v-for="request in filteredRequests" :key="request.equpmentId" cols="12" md="6" class="mb-3 mt-5">
                    <b-card class="request-card">
                        <b-card-text>
                            <div class="request-info-row" :class="[{ 'request-info-row-rtl': isRTL, 'request-info-row-ltr': !isRTL }]">
                                <span><strong>{{$t('message.requestNumber')}}:</strong>
                                    <div class="request-response"><span> {{ request.equpmentId }} </span></div>
                                </span>
                                <span class="date-time"><b-icon class="clock-icon" icon="clock"
                                        aria-hidden="true"></b-icon>{{ request.created_date }}</span>
                            </div>
                            <div style="">
                                <p class="request-info"><strong>{{$t('message.requestTitle')}}:</strong>
                                <div class="request-response"><span> {{ request.name }} </span></div>
                                </p>
                            </div>

                            <div style="" v-if="request.customer_name">
                                <p class="request-info"><strong>{{$t('message.customerNameLabel')}}:</strong>
                                <div class="request-response"><span> {{ request.customer_name }} </span></div>
                                </p>
                            </div>

                            <div style="">
                                <p class="request-info"><strong>{{$t('message.addedBy')}}:</strong>
                                <div class="request-response"> <span> {{ 'System' }}</span></div>
                                </p>
                            </div>
                            
                            
                        </b-card-text>
                        <template #footer>
                            <div @click="showDetails(request.equpmentId)" style="cursor: pointer; width: 100%;text-align: center">
                                <!-- <b-button variant="info">Show Details</b-button> -->
                                <p>{{ $t('message.showDetails') }}</p>
                            </div>
                        </template>
                    </b-card>
                </b-col>
                <template v-if="filteredRequests.length === 0">
                        <div class="text-center p-4" style="width: 100%;">
                            <!-- <lord-icon src="https://cdn.lordicon.com/wkppeqfv.json"
                                    colors="primary:#121331,secondary:#edd100" trigger="loop" style="width:100px;height:100px">
                                </lord-icon> -->
                            <img :src="require('../assets/not-found.svg')" alt="404 Photo" style="width:100%;">
                            <p class="mb-0 filter-result"> {{ $t('message.noMatchingResults') }} "{{ filter }}".</p>
                        </div>
                        </template>
            </b-row>
            <div class="mt-5 pagination">
                    <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage"></b-pagination>
            </div>
        </div>

        <!-- Modal Add Equipment -->
<b-modal
  id="add-equipment-modal"
  scrollable
  v-model="showAddModal"
  :title="$t('message.addNewEquipment')"
  size="lg"
  dialog-class="add-equipment-modal"
>
  <div class="modal-body p-4">

    

    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('message.equipmentImage')">
          <div class="image-upload-area">
            <div v-if="form.img_preview" class="image-preview-container">
              <img :src="form.img_preview" alt="Equipment Preview" class="img-preview" />
              <b-button 
                variant="danger" 
                size="sm" 
                class="remove-image-btn" 
                @click="removeImage"
              >
                <b-icon icon="x-circle"></b-icon>
              </b-button>
            </div>
            <div v-else class="upload-placeholder">
              <b-icon icon="cloud-upload" font-scale="3" class="upload-icon"></b-icon>
              <p class="upload-text">{{ $t('message.clickToUploadImage') }}</p>
              <p class="upload-hint">PNG, JPG, JPEG ({{ $t('message.max') }} 5MB)</p>
            </div>
            <input 
              type="file" 
              ref="imageInput" 
              @change="onImageSelect" 
              accept="image/*" 
              class="file-input" 
            />
          </div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentFamily')">
          <v-select :dir="direction" v-model="form.equipment_family" :options="equipmentFamilyOptions" label="name"
            :reduce="f => f" :placeholder="$t('message.selectFamily')" @open="fetchEquipmentFamily" class="custom-bg" />
          <div class="mt-2">
            <a href="javascript:void(0)" @click="showAddFamilyModal = true" class="add-family-link">
              <b-icon icon="plus-circle" class="mr-1"></b-icon>
              {{ $t('message.addNewEquipmentFamily') }}
            </a>
          </div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentType')">
          <v-select :dir="direction" v-model="form.equipment_type" :options="equipmentTypeOptions" label="label"
            :reduce="t => t.value" :placeholder="$t('message.selectEquipmentType')" class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.mainEquipment')">
          <v-select :dir="direction" v-model="form.main_equipment" :options="mainEquipmentOptions" label="name"
            :reduce="m => m" :placeholder="$t('message.selectMainEquipment')" @open="fetchMainEquipments"
            class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentName')">
          <b-form-input v-model="form.equipment_name" :placeholder="$t('message.enterEquipmentName')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentManufactor')">
          <b-form-input v-model="form.equipment_manufactor" :placeholder="$t('message.enterManufacturer')" />
        </b-form-group>
      </b-col>

      

      <b-col md="6">
        <b-form-group :label="$t('message.serialNumber')">
          <b-form-input v-model="form.serial_number" :placeholder="$t('message.enterSerial')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentModel')">
          <b-form-input v-model="form.equipment_model" :placeholder="$t('message.enterModel')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentCost')">
          <b-form-input v-model="form.cost" type="number" :placeholder="$t('message.enterCost')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentStatus')">
          <v-select :dir="direction" v-model="form.equipment_status" :options="equipmentStatusOptions"
            :placeholder="$t('message.selectStatus')" class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.additionalNotes')">
          <b-form-textarea rows="2" v-model="form.additional_note" :placeholder="$t('message.enterNotes')" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.maintenanceSchedule')">
          <b-form-checkbox-group v-model="form.maintenance" class="mt-2 d-flex flex-wrap">
            <b-form-checkbox value="daily" @change="handleMaintenanceChange('daily')">{{ $t('message.daily') }}</b-form-checkbox>
            <b-form-checkbox value="weekly" @change="handleMaintenanceChange('weekly')">{{ $t('message.weekly') }}</b-form-checkbox>
            <b-form-checkbox value="two_week" @change="handleMaintenanceChange('two_week')">{{ $t('message.twoWeek') }}</b-form-checkbox>
            <b-form-checkbox value="monthly" @change="handleMaintenanceChange('monthly')">{{ $t('message.monthly') }}</b-form-checkbox>
            <b-form-checkbox value="two_month" @change="handleMaintenanceChange('two_month')">{{ $t('message.twoMonth') }}</b-form-checkbox>
            <b-form-checkbox value="three_months" @change="handleMaintenanceChange('three_months')">{{ $t('message.threeMonth') }}</b-form-checkbox>
            <b-form-checkbox value="six_months" @change="handleMaintenanceChange('six_months')">{{ $t('message.sixMonth') }}</b-form-checkbox>
            <b-form-checkbox value="yearly" @change="handleMaintenanceChange('yearly')">{{ $t('message.yearly') }}</b-form-checkbox>
            <b-form-checkbox value="not_applicable" @change="handleMaintenanceChange('not_applicable')">{{ $t('message.notApplicable') }}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.orMaintenanceEvery')">
          <div class="d-flex align-items-center">
            <b-form-input v-model="form.units" type="number" class="mr-2" style="width: 100px" />
            <v-select :options="[{ id: 0, name: $t('message.km') }, { id: 1, name: $t('message.hour') }]" label="name"
              v-model="form.unit_type" :placeholder="$t('message.selectUnitType')" :reduce="u => u.id"
              style="width: 150px" />
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.dueDate')">
          <b-form-input 
            type="datetime-local" 
            class="custom-bg" 
            v-model="dueDateLocal"
            :min="minDateTime"
            @input="validateDueDate"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>

  <template #modal-footer>
    <div class="w-100 text-right">
      <b-button variant="outline-secondary" class="mr-2" @click="showAddModal = false">{{ $t('message.close') }}</b-button>
      <b-button variant="primary" :disabled="!isEquipmentFormValid" @click="submitEquipment">
        <b-icon icon="plus-circle" class="mr-1"></b-icon>{{ $t('message.addEquipment') }}
      </b-button>
    </div>
  </template>
</b-modal>

<!-- Add Equipment Family Modal -->
<b-modal id="add-family-modal" v-model="showAddFamilyModal" :title="$t('message.addNewEquipmentFamily')" size="md">
  <div class="modal-body p-4">
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('message.equipmentFamilyName')">
          <b-form-input v-model="familyForm.name" :placeholder="$t('message.equipmentFamilyName')" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.familyCode')">
          <b-form-input v-model="familyForm.family_code" :placeholder="$t('message.familyCode')" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.activityDomain')">
          <b-form-input v-model="familyForm.type_code" :placeholder="$t('message.activityDomain')" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>

  <template #modal-footer>
    <div class="w-100 d-flex justify-content-between">
      <b-button variant="info" @click="navigateToFamiliesList">
        <b-icon icon="list-ul" class="mr-1"></b-icon>{{ $t('message.viewAll') }}
      </b-button>
      <div>
        <b-button variant="outline-secondary" class="mr-2" @click="showAddFamilyModal = false">
          {{ $t('message.close') }}
        </b-button>
        <b-button variant="primary" :disabled="!isFamilyFormValid" @click="submitEquipmentFamily">
          <b-icon icon="plus-circle" class="mr-1"></b-icon>{{ $t('message.addFamily') }}
        </b-button>
      </div>
    </div>
  </template>
</b-modal>

    </div>
</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex'
import VSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    name: "about",
    components: {
        VSelect 
    },
    data() {
        return {
            filter: '',
            requests: [],
            rows: 0,
            currentPage: 1,
            perPage: 10,
            isLoading: true,
            showAddModal: false,
            showAddFamilyModal: false,
      equipmentFamilyOptions: [],
      mainEquipmentOptions: [],
      form: {
        equipment_family: null,
        main_equipment: null,
        serial_number: '',
        cost: '',
        equipment_type: '',
        equipment_model: '',
        equipment_manufactor: '',
        equipment_name: '',
        equipment_status: '',
        additional_note: '',
        maintenance: [],
        units: '',
        unit_type: 0,
        img_url: null,
        img_preview: null,
      },
      familyForm: {
        name: '',
        family_code: '',
        type_code: '',
      },
      dueDate: '',
        };

    },
    computed: {
        ...mapGetters(['getUser']),
        company_id() {
            return this.getUser; // استخدام الـ getter لجلب بيانات المستخدم
        },
        filteredRequests() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            const filtered = this.requests.filter(request =>
            request.name.toLowerCase().includes(this.filter.toLowerCase())
            );
            this.rows = filtered.length; // تحديث إجمالي الصفوف بعد التصفية
            return filtered.slice(start, end);
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        direction() {
            return this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
        },
        equipmentStatusOptions() {
            return [
                this.$t('message.statusNew'),
                this.$t('message.statusUsed')
            ];
        },
        equipmentTypeOptions() {
            // Equipment types from Excel with Arabic and English labels
            const types = [
                { value: 'Fuel tanks', label_ar: 'خزانات وقود', label_en: 'Fuel tanks' },
                { value: 'Metallic pipes', label_ar: 'أنابيب معدنية', label_en: 'Metallic pipes' },
                { value: 'Non metallic pipes', label_ar: 'أنابيب غير معدنية', label_en: 'Non metallic pipes' },
                { value: 'LPG Tank', label_ar: 'خزان غاز البترول المسال (LPG)', label_en: 'LPG Tank' },
                { value: 'Submersible pump', label_ar: 'مضخة غاطسة', label_en: 'Submersible pump' },
                { value: 'Cathodic protection', label_ar: 'حماية كاثودية', label_en: 'Cathodic protection' },
                { value: 'Controlled driver delivery', label_ar: 'توصيل سائق متحكم به', label_en: 'Controlled driver delivery' },
                { value: 'Tank gauging', label_ar: 'قياس الخزانات', label_en: 'Tank gauging' },
                { value: 'Vapour recovery system S1', label_ar: 'نظام استعادة البخار S1', label_en: 'Vapour recovery system S1' },
                { value: 'E-Fuel nozzle', label_ar: 'فوهة وقود إلكترونية', label_en: 'E-Fuel nozzle' },
                { value: 'Fixed fire-fighting systems', label_ar: 'أنظمة إطفاء حريق ثابتة', label_en: 'Fixed fire-fighting systems' },
                { value: 'Fuel dispenser', label_ar: 'موزع وقود', label_en: 'Fuel dispenser' },
                { value: 'Integrated Card reader', label_ar: 'قارئ بطاقات مدمج', label_en: 'Integrated Card reader' },
                { value: 'LPG dispenser', label_ar: 'موزع غاز البترول المسال (LPG)', label_en: 'LPG dispenser' },
                { value: 'Pump controller', label_ar: 'وحدة تحكم بالمضخة', label_en: 'Pump controller' },
                { value: 'Satellite dispenser', label_ar: 'موزع فرعي (ساتلايت)', label_en: 'Satellite dispenser' },
                { value: 'Two-stroke or motorbike dispenser', label_ar: 'موزع وقود لمحركات ثنائية الشوط أو دراجات نارية', label_en: 'Two-stroke or motorbike dispenser' },
                { value: 'Vapour recovery system S2', label_ar: 'نظام استعادة البخار S2', label_en: 'Vapour recovery system S2' },
                { value: 'Air & water unit', label_ar: 'وحدة هواء وماء', label_en: 'Air & water unit' },
                { value: 'Air compressor', label_ar: 'ضاغط هواء', label_en: 'Air compressor' },
                { value: 'Canopies', label_ar: 'مظلات', label_en: 'Canopies' },
                { value: 'Forecourt slab and gutters', label_ar: 'بلاط و مصارف الساحة الأمامية', label_en: 'Forecourt slab and gutters' },
                { value: 'Kiosk', label_ar: 'كشك', label_en: 'Kiosk' },
                { value: 'Oil separator & interceptor', label_ar: 'فاصل ومصيدة الزيت', label_en: 'Oil separator & interceptor' },
                { value: 'Air conditioning', label_ar: 'تكييف هواء', label_en: 'Air conditioning' },
                { value: 'Heating equipment', label_ar: 'معدات تدفئة', label_en: 'Heating equipment' },
                { value: 'Ventilation', label_ar: 'تهوية', label_en: 'Ventilation' },
                { value: 'Solar air conditioning', label_ar: 'تكييف هواء شمسي', label_en: 'Solar air conditioning' },
                { value: 'Cold room and walk-in cooler', label_ar: 'غرفة تبريد ومبرد داخلي', label_en: 'Cold room and walk-in cooler' },
                { value: 'Fridge and refrigeration', label_ar: 'ثلاجة وتبريد', label_en: 'Fridge and refrigeration' },
                { value: 'Shop fittings and furnitures', label_ar: 'تجهيزات ومفروشات المتجر', label_en: 'Shop fittings and furnitures' },
                { value: 'Automatic door', label_ar: 'باب أوتوماتيكي', label_en: 'Automatic door' },
                { value: 'Lift, Hoistaway', label_ar: 'مصعد، رافعة', label_en: 'Lift, Hoistaway' },
                { value: 'Roller shutters', label_ar: 'ستائر دوارة', label_en: 'Roller shutters' },
                { value: 'Fast food and bar equipment', label_ar: 'معدات الوجبات السريعة والبار', label_en: 'Fast food and bar equipment' },
                { value: 'Grease interceptor', label_ar: 'مصيدة الشحوم', label_en: 'Grease interceptor' },
                { value: 'Restaurant fittings and furnitures', label_ar: 'تجهيزات ومفروشات المطعم', label_en: 'Restaurant fittings and furnitures' },
                { value: 'Jet Wash', label_ar: 'غسيل بالضغط العالي', label_en: 'Jet Wash' },
                { value: 'Roll over Car Wash', label_ar: 'غسيل سيارات أوتوماتيكي (رول أوفر)', label_en: 'Roll over Car Wash' },
                { value: 'Vacuum cleaner', label_ar: 'مكنسة كهربائية', label_en: 'Vacuum cleaner' },
                { value: 'Separator & interceptor', label_ar: 'فاصل ومصيدة', label_en: 'Separator & interceptor' },
                { value: 'Water recycling', label_ar: 'إعادة تدوير المياه', label_en: 'Water recycling' },
                { value: 'Used oil tank', label_ar: 'خزان زيت مستعمل', label_en: 'Used oil tank' },
                { value: 'Bay material', label_ar: 'مواد الخليج (منطقة الخدمة)', label_en: 'Bay material' },
                { value: 'Oil change equipment', label_ar: 'معدات تغيير الزيت', label_en: 'Oil change equipment' },
                { value: 'Car lift', label_ar: 'رافعة سيارات', label_en: 'Car lift' },
                { value: 'HV Transformer', label_ar: 'محول جهد عالي (HV)', label_en: 'HV Transformer' },
                { value: 'Lighting equipment', label_ar: 'معدات إضاءة', label_en: 'Lighting equipment' },
                { value: 'UPS', label_ar: 'نظام إمداد الطاقة غير المنقطع (UPS)', label_en: 'UPS' },
                { value: 'Comms cables into DOMS', label_ar: 'كابلات الاتصالات إلى نظام DOMS', label_en: 'Comms cables into DOMS' },
                { value: 'Electrical distribution', label_ar: 'توزيع كهربائي', label_en: 'Electrical distribution' },
                { value: 'Electrical generator set', label_ar: 'مجموعة مولدات كهربائية', label_en: 'Electrical generator set' },
                { value: 'PV Generation', label_ar: 'توليد الطاقة الشمسية الكهروضوئية (PV)', label_en: 'PV Generation' },
                { value: 'Solar equipment', label_ar: 'معدات شمسية', label_en: 'Solar equipment' },
                { value: 'Bullet-proof cabin', label_ar: 'كابينة مضادة للرصاص', label_en: 'Bullet-proof cabin' },
                { value: 'Closed-Circuit TV', label_ar: 'تلفزيون الدائرة المغلقة (CCTV)', label_en: 'Closed-Circuit TV' },
                { value: 'Fire extinguishers', label_ar: 'طفايات حريق', label_en: 'Fire extinguishers' },
                { value: 'Flame detector & alarm system', label_ar: 'كاشف لهب ونظام إنذار', label_en: 'Flame detector & alarm system' },
                { value: 'Lock & Safe', label_ar: 'قفل وخزنة', label_en: 'Lock & Safe' },
                { value: 'Back-office system', label_ar: 'نظام المكتب الخلفي', label_en: 'Back-office system' },
                { value: 'POS (Front-Office)', label_ar: 'نقطة بيع (المكتب الأمامي)', label_en: 'POS (Front-Office)' },
                { value: 'Stand Alone Card Reader', label_ar: 'قارئ بطاقات مستقل', label_en: 'Stand Alone Card Reader' },
                { value: 'HP POS (HARDWARE)', label_ar: 'نقطة بيع HP (أجهزة)', label_en: 'HP POS (HARDWARE)' },
                { value: 'OASIS BOS (SOFTWARE)', label_ar: 'نظام المكتب الخلفي OASIS (برمجيات)', label_en: 'OASIS BOS (SOFTWARE)' },
                { value: 'OASIS POS (SOFTWARE)', label_ar: 'نقطة بيع OASIS (برمجيات)', label_en: 'OASIS POS (SOFTWARE)' },
                { value: 'Audio & Visual', label_ar: 'صوتيات ومرئيات', label_en: 'Audio & Visual' },
                { value: 'Router', label_ar: 'موجه (راوتر)', label_en: 'Router' },
                { value: 'Switch', label_ar: 'محول شبكة (سويتش)', label_en: 'Switch' },
                { value: 'START BOX (VMWARE)', label_ar: 'صندوق START (VMWARE)', label_en: 'START BOX (VMWARE)' },
                { value: 'START CONNECTIVITY', label_ar: 'اتصال START', label_en: 'START CONNECTIVITY' },
                { value: 'Other branding equipment', label_ar: 'معدات علامة تجارية أخرى', label_en: 'Other branding equipment' },
                { value: 'Poster', label_ar: 'ملصق', label_en: 'Poster' },
                { value: 'Totem & Pole Sign', label_ar: 'لافتة عمودية ولوحة إرشادية', label_en: 'Totem & Pole Sign' },
                { value: 'Fresh water treatment', label_ar: 'معالجة المياه العذبة', label_en: 'Fresh water treatment' },
                { value: 'Waste water treatment plant', label_ar: 'محطة معالجة مياه الصرف الصحي', label_en: 'Waste water treatment plant' },
                { value: 'Circulation areas & car parks', label_ar: 'مناطق الحركة ومواقف السيارات', label_en: 'Circulation areas & car parks' },
                { value: 'Gas bottle recipient', label_ar: 'مستقبل أسطوانات الغاز', label_en: 'Gas bottle recipient' },
                { value: 'Road utility vehicles', label_ar: 'مركبات خدمة الطرق', label_en: 'Road utility vehicles' },
                { value: 'Boundary walls-Fences', label_ar: 'جدران حدودية - أسوار', label_en: 'Boundary walls-Fences' },
                { value: 'Green Areas', label_ar: 'مناطق خضراء', label_en: 'Green Areas' },
                { value: 'Portal', label_ar: 'بوابة', label_en: 'Portal' },
                { value: 'Building', label_ar: 'مبنى', label_en: 'Building' },
                { value: 'Roof', label_ar: 'سقف', label_en: 'Roof' }
            ];
            
            return types.map(type => ({
                value: type.value,
                label: this.isRTL ? type.label_ar : type.label_en
            }));
        },
        isFamilyFormValid() {
            return this.familyForm.name && this.familyForm.family_code;
        },
        isEquipmentFormValid() {
            const f = this.form;
            return f.serial_number && f.equipment_type && f.equipment_model;
        },
        minDateTime() {
            // إرجاع التاريخ والوقت الحالي بصيغة datetime-local (للـ due_date)
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        dueDateLocal: {
            get() {
                // تحويل من YYYY-MM-DD HH:mm:ss إلى YYYY-MM-DDTHH:mm
                if (!this.dueDate) return '';
                const [datePart, timePart] = this.dueDate.split(' ');
                if (!datePart || !timePart) return '';
                const [hours, minutes] = timePart.split(':');
                return `${datePart}T${hours}:${minutes}`;
            },
            set(value) {
                // تحويل من YYYY-MM-DDTHH:mm إلى YYYY-MM-DD HH:mm:ss
                if (!value) {
                    this.dueDate = '';
                    return;
                }
                const [datePart, timePart] = value.split('T');
                if (!datePart || !timePart) return;
                const [hours, minutes] = timePart.split(':');
                const now = new Date();
                const seconds = String(now.getSeconds()).padStart(2, '0');
                this.dueDate = `${datePart} ${hours}:${minutes}:${seconds}`;
            }
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        validateDueDate(event) {
            const selectedValue = event.target.value;
            if (!selectedValue) return;
            
            const selectedDateTime = new Date(selectedValue);
            const currentDateTime = new Date();
            
            // إذا كان التاريخ المختار في الماضي، قم بتعيينه للوقت الحالي
            if (selectedDateTime.getTime() < currentDateTime.getTime()) {
                // استخدام formatDateTime للحصول على التنسيق الصحيح
                this.dueDate = this.formatDateTime(new Date());
                
                this.$izitoast.warning({
                    title: this.$t('message.warning'),
                    message: this.$t('message.cannotSelectPastDateTime') || 'لا يمكن اختيار تاريخ أو وقت في الماضي',
                    position: 'bottomLeft',
                    timeout: 3000
                });
            }
        },
         openAddEquipmentModal() {
      this.showAddModal = true;
    },
    handleMaintenanceChange(value) {
      // استخدام $nextTick للتأكد من أن v-model تم تحديثه أولاً
      this.$nextTick(() => {
        const otherOptions = ['daily', 'weekly', 'two_week', 'monthly', 'two_month', 'three_months', 'six_months', 'yearly'];
        
        if (value === 'not_applicable') {
          // إذا تم اختيار N/A، قم بإلغاء جميع الخيارات الأخرى
          if (this.form.maintenance.includes('not_applicable')) {
            this.form.maintenance = ['not_applicable'];
          }
        } else {
          // إذا تم اختيار أي خيار آخر، قم بإلغاء N/A إذا كان موجودًا
          if (this.form.maintenance.includes('not_applicable')) {
            this.form.maintenance = this.form.maintenance.filter(item => item !== 'not_applicable');
          }
        }
      });
    },
    async fetchEquipmentFamily() {
      const formData = new FormData();
      formData.append('company_id', this.company_id.company_id);
      const res = await axiosInstance.post('company/select_equipments_family.php', formData);
      if (res.data.status === "true") this.equipmentFamilyOptions = res.data.output;
    },

    async fetchMainEquipments() {
      const formData = new FormData();
      formData.append('company_id', this.company_id.company_id);
      const res = await axiosInstance.post('company/select_equipments.php', formData);
      if (res.data.status === "true") this.mainEquipmentOptions = res.data.output;
    },

    async submitEquipment() {
      try {
        const f = this.form;

        const isNotApplicable = f.maintenance.includes('not_applicable');
        const maintenanceFlags = {
          daily: isNotApplicable ? 0 : (f.maintenance.includes('daily') ? 1 : 0),
          weekly: isNotApplicable ? 0 : (f.maintenance.includes('weekly') ? 1 : 0),
          two_week: isNotApplicable ? 0 : (f.maintenance.includes('two_week') ? 1 : 0),
          monthly: isNotApplicable ? 0 : (f.maintenance.includes('monthly') ? 1 : 0),
          two_month: isNotApplicable ? 0 : (f.maintenance.includes('two_month') ? 1 : 0),
          three_months: isNotApplicable ? 0 : (f.maintenance.includes('three_months') ? 1 : 0),
          six_months: isNotApplicable ? 0 : (f.maintenance.includes('six_months') ? 1 : 0),
          yearly: isNotApplicable ? 0 : (f.maintenance.includes('yearly') ? 1 : 0),
        };

        const formData = new FormData();
        formData.append('name', f.equipment_name || '');
        formData.append('serial_number', f.serial_number || '');
        formData.append('equipment_family_id', f.equipment_family?.id || 0);
        formData.append('equipment_type', f.equipment_type || '');
        formData.append('equipment_model', f.equipment_model || '');
        formData.append('equipment_manufactor', f.equipment_manufactor || '');
        formData.append('equipment_id', f.main_equipment?.equpmentId || f.main_equipment?.id || 0);
        formData.append('company_id', this.company_id.company_id);
        formData.append('equipment_status', f.equipment_status || '');
        formData.append('additional_note', f.additional_note || '');
        formData.append('admin_id', this.company_id.id);
        formData.append('description', f.additional_note || '');
        formData.append('siteId', 0);
        formData.append('units', f.units || '');
        formData.append('unit_type', f.unit_type ?? 0);
        formData.append('start_pm_date_mentainance', this.dueDate || '');

        if (f.img_preview) {
          const base64 = f.img_preview.replace(/^data:image\/\w+;base64,/, '');
          formData.append('encoded_image', base64);
        }

        Object.entries(maintenanceFlags).forEach(([k, v]) => formData.append(k, v));

        const res = await axiosInstance.post('admin/insert_equipment.php', formData);

        if (res.data.status === "true") {
          this.$izitoast.success({
            title: 'Success',
            message: 'Equipment added successfully!',
            position: 'bottomLeft',
          });
          this.showAddModal = false;
          this.dueDate = '';
          this.fetchData(); // refresh list
        } else {
          this.$izitoast.error({
            title: 'Error',
            message: 'Error adding equipment.',
            position: 'bottomLeft',
          });
        }
      } catch (e) {
        console.error(e);
        this.$izitoast.error({
          title: 'Error',
          message: 'Error occurred while sending data.',
          position: 'bottomLeft',
        });
      }
    },

    async submitEquipmentFamily() {
      try {
        const formData = new FormData();
        formData.append('company_id', this.company_id.company_id);
        formData.append('name', this.familyForm.name);
        formData.append('family_code', this.familyForm.family_code);
        formData.append('type_code', this.familyForm.type_code || '');

        const res = await axiosInstance.post('company/insert_equipment_family.php', formData);

        if (res.data.status === "true") {
          this.$izitoast.success({
            title: this.$t('message.success'),
            message: this.$t('message.familyAddedSuccessfully'),
            position: 'bottomLeft',
          });
          
          // Reset form
          this.familyForm = {
            name: '',
            family_code: '',
            type_code: '',
          };
          
          this.showAddFamilyModal = false;
          
          // Refresh equipment families list
          this.fetchEquipmentFamily();
        } else {
          this.$izitoast.error({
            title: this.$t('message.error'),
            message: this.$t('message.errorAddingEquipment'),
            position: 'bottomLeft',
          });
        }
      } catch (e) {
        console.error(e);
        this.$izitoast.error({
          title: this.$t('message.error'),
          message: this.$t('message.errorSendingData'),
          position: 'bottomLeft',
        });
      }
    },

    navigateToFamiliesList() {
      this.$router.push('/equipment-families');
    },

    onImageSelect(event) {
      const file = event.target.files[0];
      if (file) {
        // التحقق من حجم الملف (5MB max)
        if (file.size > 5 * 1024 * 1024) {
          this.$izitoast.error({
            title: this.$t('message.error'),
            message: this.$t('message.fileTooLarge'),
            position: 'bottomLeft',
          });
          return;
        }

        // التحقق من نوع الملف
        if (!file.type.startsWith('image/')) {
          this.$izitoast.error({
            title: this.$t('message.error'),
            message: this.$t('message.invalidFileType'),
            position: 'bottomLeft',
          });
          return;
        }

        this.form.img_url = file;
        
        // إنشاء preview للصورة
        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.img_preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    removeImage() {
      this.form.img_url = null;
      this.form.img_preview = null;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },

        async fetchData() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;
            console.log(formattedDate);
            try {
                const formData = new FormData();
                formData.append('current_date', formattedDate);
                // formData.append('offset', 0);
                formData.append('company_id', this.company_id.company_id);
                formData.append('days', 3);
                const response = await axiosInstance.post('company/select_pm_orders.php', formData);

                console.log(response.data);
                if (response.data.status === "true") {
                    this.requests = response.data.output;
                    console.log('requests = ', this.requests);
                    this.isLoading = false;

                }
            } catch (error) {
                console.error('Error logging in:', error)
                this.$izitoast.error({
                    title: 'Error',
                    message: 'An error occurred while trying to get data',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
                this.isLoading = false;
            }
        },
        showDetails(itemId){
            // this.$router.push('show-details/' + itemId);
            // this.$router.push(`/requests/${itemId}/this.$router.push('/addNewOrder');`);
            this.$router.push(`/addNewOrder/${itemId}`);
            // /requests/:id/details
        },
        
    }
}

</script>

<style scoped>
.request-card {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
}

.b-pagination-pills .page-item .page-link {
    line-height: 0.8;
}

.request-info {
    margin-bottom: 0px !important;
}

p,
.request-info-row {
    margin-bottom: 0px !important;
}

/* .request-info-row strong {
    margin-right: 38px !important;
} */

.card-footer p {
    margin-bottom: 0px !important;
    font-family: 'Somar-Bold';
    font-size: 21px;
}

.date-time {
    color: #777D85 !important;
}

.card-footer:hover {
    background-color: #3C89CE !important;
    transition: all 0.3s ease-in-out !important;
    cursor: pointer;
    border-bottom-right-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
}

.card-footer:hover p {
    color: #fff !important;
    transition: all 0.3s ease-in-out !important;
}
.new-order{
    background-image: linear-gradient(90deg, #FFCA1F 0%, #FFD44A 100%);
    border-radius: 20px;
    color: #fff;
    width: 200px;
    font-size: 21px;
    font-family: 'Somar-bold';
    border-width: 0px;
}
.new-order:hover{
    outline: none;
    border-width: 0px;
    background-image: linear-gradient(90deg, #FFD44A 0%, #FFCA1F 100%);
    transition: all 0.3s ease-in-out;
    color: #fff;
}
.pagination{
    justify-content: center;
    display: flex;
    align-items: center;
}
/* ---------- Modal Layout ---------- */
.add-equipment-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15);
  border: none;
}

/* Header gradient style */
.add-equipment-modal .modal-header {
  background: linear-gradient(90deg, #ffcc33, #ffb400);
  color: #fff;
  font-family: 'Somar-Bold';
  font-size: 20px;
  border-bottom: none;
  padding: 16px 20px;
}

/* Body area spacing and scroll */


/* Labels and input spacing */
.add-equipment-modal .form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  font-size: 15px;
}



/* Checkboxes area */
.add-equipment-modal .b-form-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}

.add-equipment-modal .b-form-checkbox {
  background-color: #fff;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

/* Maintenance section title */
.add-equipment-modal .b-form-group[aria-label="Maintenance Schedule"] {
  margin-top: 20px;
}

/* Alert styling */
.equipment-alert {
  border-radius: 10px;
  background-color: #fff8e1;
  border: 1px solid #ffe58f;
  color: #8c6d1f;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  box-shadow: 0px 2px 8px rgba(255, 193, 7, 0.2);
  margin-bottom: 20px;
}

/* Footer */
.add-equipment-modal .modal-footer {
  background-color: #fff;
  padding: 15px 20px;
  border-top: 1px solid #eee;
  justify-content: flex-end;
}

.add-equipment-modal .modal-footer .btn {
  border-radius: 10px;
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 600;
}

.add-equipment-modal .btn-primary {
  background: linear-gradient(90deg, #ffb400, #ffca1f);
  border: none;
}

.add-equipment-modal .btn-primary:hover {
  background: linear-gradient(90deg, #ffca1f, #ffb400);
}

.add-equipment-modal .btn-outline-secondary {
  border-color: #ccc;
  color: #555;
}

.add-family-link {
  color: #2274BD;
  font-family: 'Somar-Bold';
  font-size: 14px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
}

.add-family-link:hover {
  color: #FFD448;
  text-decoration: underline;
}

/* Image Upload Styling */
.image-upload-area {
  position: relative;
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f9fafb;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload-area:hover {
  border-color: #FFB400;
  background: #fffbf0;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-icon {
  color: #9ca3af;
  margin-bottom: 12px;
}

.upload-text {
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
  font-size: 16px;
}

.upload-hint {
  color: #9ca3af;
  font-size: 14px;
  margin-bottom: 0;
}

.image-preview-container {
  position: relative;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
}

.img-preview {
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.remove-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

/* Responsive */
@media (max-width: 768px) {
    .new-order {
        width: 100%;
        font-size: 18px;
        margin: 10px 0;
    }
}

@media (max-width: 576px) {
    .filter-text {
        font-size: 20px !important;
    }
    
    .filter-input {
        width: 120px !important;
    }
}

</style>